import quests from '../../data/quests'
import Quest from '../../models/Quest'



// initial state
const state = () => ({

})

// getters
const getters = {
    stats: () => {
        const quests = Quest.all()
        const stats = {}
        stats.total = quests.length
        stats.completed = quests.filter((quest) => quest.completed).length
        stats.progress = Math.round(stats.completed / stats.total * 100)
        return stats
    },
    filtered: (state, getters, rootState) => {
        switch(rootState.configurations.filter) {
          case "completed":
            return Quest.query().where('completed', true).get()
          case "uncompleted":
            return Quest.query().where('completed', false).get()
          default:
            return Quest.query().all();
        }
    }
}

// actions
const actions = {
    load({ commit }) {
        commit('load', quests)
    },
    complete({ commit }, quest) {
        commit('complete', { quest })
    },
    uncomplete({ commit }, quest) {
        commit('uncomplete', { quest })
    }
}

// mutations
const mutations = {
    load(state, quests) {
        // Restore completed quests
        quests.forEach(quest => {
            if (Quest.query().where((persistedQuest) => { return persistedQuest.completed && persistedQuest.id == quest.id }).exists()) {
                quest.completed = true
            }
        });
        Quest.create({
            data: quests
        })
    },
    complete(state, { quest }) {
        Quest.update({
            where: quest.id,
            data: {
                completed: true
            }
        })
    },
    uncomplete(state, { quest }) {
        Quest.update({
            where: quest.id,
            data: {
                completed: false
            }
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}